import React from 'react';
import { useTranslation } from 'react-i18next';
import './WelcomeScreen.css';

function WelcomeScreen({ onStart }) {
  const { t } = useTranslation();

  return (
    <div className="welcome-screen">
      <div className="welcome-header">
        <h1>{t('onboarding.welcome.title')}</h1>
        <p>{t('onboarding.welcome.subtitle')}</p>
      </div>

      <div className="welcome-steps">
        <div className="welcome-step">
          <div className="step-icon">🎤</div>
          <h3>{t('onboarding.welcome.steps.voice')}</h3>
          <p>{t('onboarding.voice.description')}</p>
        </div>
        <div className="welcome-step">
          <div className="step-icon">✅</div>
          <h3>{t('onboarding.welcome.steps.consent')}</h3>
          <p>{t('onboarding.consent.description')}</p>
        </div>
        <div className="welcome-step">
          <div className="step-icon">📄</div>
          <h3>{t('onboarding.welcome.steps.contract')}</h3>
          <p>{t('onboarding.contract.intro')}</p>
        </div>
      </div>

      <button onClick={onStart} className="start-button">
        {t('onboarding.welcome.start_button')}
      </button>
    </div>
  );
}

export default WelcomeScreen;

